import ACHTransfersStrategy from './AppDetails/Strategies/ACHTransfersStrategy';
import AlexaStrategy from './AppDetails/Strategies/AlexaStrategy';
import ApiKeysManagementStrategy from './AppDetails/Strategies/ApiKeysManagementStrategy';
import BeelineRoutesStrategy from './AppDetails/Strategies/BeelineRoutesStrategy';
import BroadlyStrategy from './AppDetails/Strategies/BroadlyStrategy';
import CallRailStrategy from './AppDetails/Strategies/CallRailStrategy';
import ChatOnYourWebsiteStrategy from './AppDetails/Strategies/ChatOnYourWebsiteStrategy';
import ChecklistsStrategy from './AppDetails/Strategies/ChecklistsStrategy';
import CompanycamStrategy from './AppDetails/Strategies/CompanycamStrategy';
import ConvertStrategy from './AppDetails/Strategies/ConvertStrategy';
import CreditCardProccessingStrategy from './AppDetails/Strategies/CreditCardProccessingStrategy';
import DispatchStrategy from './AppDetails/Strategies/DispatchStrategy';
import ECommerceStrategy from './AppDetails/Strategies/ECommerceStrategy';
import EmailStrategy from './AppDetails/Strategies/EmailStrategy';
import FacebookBookingStrategy from './AppDetails/Strategies/FacebookBookingStrategy';
import FlatRatePricingStrategy from './AppDetails/Strategies/FlatRatePricingStrategy';
import FundboxStrategy from './AppDetails/Strategies/FundboxStrategy';
import GiftUpStrategy from './AppDetails/Strategies/GiftUpStrategy';
import GoogleCalendarStrategy from './AppDetails/Strategies/GoogleCalendarStrategy';
import GoogleReserveStrategy from './AppDetails/Strategies/GoogleReserveStrategy';
import GustoStrategy from './AppDetails/Strategies/GustoStrategy';
import HousecallBookingStrategy from './AppDetails/Strategies/HousecallBookingStrategy';
import InstapayStrategy from './AppDetails/Strategies/InstapayStrategy';
import JobCostStrategy from './AppDetails/Strategies/JobCostStrategy';
import JobInboxStrategy from './AppDetails/Strategies/JobInboxStrategy';
import MailchimpStrategy from './AppDetails/Strategies/MailchimpStrategy';
import MeasureQuickStrategy from './AppDetails/Strategies/MeasureQuickStrategy';
import MojioStrategy from './AppDetails/Strategies/MojioStrategy';
import NiceJobStrategy from './AppDetails/Strategies/NiceJobStrategy';
import OnCallAirStrategy from './AppDetails/Strategies/OnCallAirStrategy';
import OnlineBookingStrategy from './AppDetails/Strategies/OnlineBookingStrategy';
import PodiumStrategy from './AppDetails/Strategies/PodiumStrategy';
import PostcardStrategy from './AppDetails/Strategies/PostcardStrategy';
import ProfitRhinoStrategy from './AppDetails/Strategies/ProfitRhinoStrategy';
import PropertyProfileStrategy from './AppDetails/Strategies/PropertyProfileStrategy';
import QboStrategy from './AppDetails/Strategies/QboStrategy';
import QuickbooksDesktopStrategy from './AppDetails/Strategies/QuickbooksDesktopStrategy';
import ResponsibidStrategy from './AppDetails/Strategies/ResponsibidStrategy';
import ReviewsStrategy from './AppDetails/Strategies/ReviewsStrategy';
import SalesProposalStrategy from './AppDetails/Strategies/SalesProposalStrategy';
import ScheduleEngineStrategy from './AppDetails/Strategies/ScheduleEngineStrategy';
import ServiceAgreementsStrategy from './AppDetails/Strategies/ServiceAgreementsStrategy';
import SignpostStrategy from './AppDetails/Strategies/SignpostStrategy';
import SuperProStrategy from './AppDetails/Strategies/SuperProStrategy';
import TimesheetStrategy from './AppDetails/Strategies/TimesheetStrategy';
import TimeTrackingStrategy from './AppDetails/Strategies/TimeTrackingStrategy';
import TradeAcademyStrategy from './AppDetails/Strategies/TradeAcademyStrategy';
import VehicleGpsTrackingStrategy from './AppDetails/Strategies/VehicleGpsTrackingStrategy';
import WebhooksStrategy from './AppDetails/Strategies/WebhooksStrategy';
import WebsiteBuilderStrategy from './AppDetails/Strategies/WebsiteBuilderStrategy';
import WebsitesStrategy from './AppDetails/Strategies/WebsitesStrategy';
import WisetackStrategy from './AppDetails/Strategies/WisetackStrategy';
import ZapierStrategy from './AppDetails/Strategies/ZapierStrategy';

const hash = {
  gcal: GoogleCalendarStrategy,
  qbo: QboStrategy,
  time_tracking: TimeTrackingStrategy,
  timesheet: TimesheetStrategy,
  facebook_booking: FacebookBookingStrategy,
  instapay: InstapayStrategy,
  online_booking: OnlineBookingStrategy,
  housecall_app_booking: HousecallBookingStrategy,
  email_marketing: EmailStrategy,
  postcard_marketing: PostcardStrategy,
  credit_card_processing: CreditCardProccessingStrategy,
  ach_transfers: ACHTransfersStrategy,
  nice_job: NiceJobStrategy,
  convert: ConvertStrategy,
  zapier: ZapierStrategy,
  broadly: BroadlyStrategy,
  service_agreements: ServiceAgreementsStrategy,
  fundbox: FundboxStrategy,
  reviews: ReviewsStrategy,
  website_builder: WebsiteBuilderStrategy,
  superpro: SuperProStrategy,
  on_call_air: OnCallAirStrategy,
  sales_proposal: SalesProposalStrategy,
  property_profile: PropertyProfileStrategy,
  call_rail: CallRailStrategy,
  wisetack: WisetackStrategy,
  gusto: GustoStrategy,
  podium: PodiumStrategy,
  checklists: ChecklistsStrategy,
  gift_up: GiftUpStrategy,
  mailchimp: MailchimpStrategy,
  local_services_ads: GoogleReserveStrategy,
  responsibid: ResponsibidStrategy,
  quickbooks_desktop: QuickbooksDesktopStrategy,
  job_cost: JobCostStrategy,
  alexa: AlexaStrategy,
  dispatch: DispatchStrategy,
  webhooks: WebhooksStrategy,
  e_commerce: ECommerceStrategy,
  companycam: CompanycamStrategy,
  signpost: SignpostStrategy,
  schedule_engine: ScheduleEngineStrategy,
  job_inbox: JobInboxStrategy,
  mojio: MojioStrategy,
  vehicle_gps_tracking: VehicleGpsTrackingStrategy,
  trade_academy: TradeAcademyStrategy,
  flat_rate_pricing: FlatRatePricingStrategy,
  beeline_routes: BeelineRoutesStrategy,
  chat_on_your_website: ChatOnYourWebsiteStrategy,
  measurequick: MeasureQuickStrategy,
  profit_rhino: ProfitRhinoStrategy,
  api_key_management: ApiKeysManagementStrategy,
  websites: WebsitesStrategy,
};

export default hash;
